
<div style="width: 100%; margin-top: 5px;">
	<label for="" style="margin-bottom: 0px;">Show or hide columns:</label>
	<br>
	<span class="column-badge" *ngFor="let column of columns">
		<span class="badge badge-label" [ngClass]="column.showed ? 'bg-primary' : 'bg-danger'" (click)="toogleColumn(column)"><i class="mdi mdi-circle-medium"></i> {{column.name}}</span>
	</span>
</div>
